export default __webpack_public_path__ + "847e7f35e8bb373b5496e3f9aae2dee1.jpg";